import { render, staticRenderFns } from "./AllClientLogs.vue?vue&type=template&id=4de64878"
import script from "./AllClientLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./AllClientLogs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AllClientLogs.vue?vue&type=style&index=0&id=4de64878&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports